import { BUCKETS } from './BUCKETS';

/** Banner principal Medi-Commerce (catálogo, categorías, búsqueda y filtros). */
export const MEDICOMMERCE_BANNER_URL = `https://${BUCKETS.bucketAssets}.s3.us-east-1.amazonaws.com/images/banners/category_banner.avif`;

/** Banner desktop genérico (catálogo premiums y categorías sin imagen propia). */
export const CATEGORY_DEFAULT_BANNER_DESKTOP_URL = MEDICOMMERCE_BANNER_URL;

/** Banner mobile genérico (catálogo premiums y categorías sin imagen propia). */
export const CATEGORY_DEFAULT_BANNER_MOBILE_URL = MEDICOMMERCE_BANNER_URL;
